import type { WorkstationTermsStatus } from '@localagent/sdk';
import { Button } from '@localagent/ui/components/button';

export type WorkstationTermsSectionProps = {
  terms: WorkstationTermsStatus;
  accepting: boolean;
  error?: string;
  onAccept: () => void;
};

export function WorkstationTermsSection({
  terms,
  accepting,
  error,
  onAccept,
}: WorkstationTermsSectionProps) {
  return (
    <section className="space-y-4" data-testid="workstation-terms-section">
      <div>
        <h2 className="text-title-2 font-semibold">Cloud workstation terms</h2>
        <p className="text-body text-muted-foreground">
          Cloud bash remains disabled until you accept the current version for this account.
        </p>
      </div>
      <div className="space-y-4 rounded-lg bg-card p-4">
        <div>
          <h3 className="font-medium">{terms.title}</h3>
          <p className="mt-1 text-caption text-muted-foreground">Version {terms.version}</p>
        </div>
        <div className="space-y-3 whitespace-pre-line text-body leading-6">{terms.body}</div>
        {terms.accepted ? (
          <p className="text-label font-medium text-success-text" role="status">
            Accepted{terms.accepted_at ? ` on ${new Date(terms.accepted_at).toLocaleString()}` : ''}
          </p>
        ) : (
          <Button size="sm" disabled={accepting} onClick={onAccept}>
            {accepting ? 'Accepting…' : 'Accept and enable cloud bash'}
          </Button>
        )}
        {error && <p className="text-body text-destructive" role="alert">{error}</p>}
      </div>
    </section>
  );
}
